<ub-card [variant]="'primary'" [rounded]="true" [dividers]="false">
  <h3 title>{{ venue.doc.name ?? getDefaultTitle() }}</h3>
  <div content>
    <eas-translation-info-list *ngIf="venue.doc.translationInfo" [translationInfo]="venue.doc.translationInfo">
    </eas-translation-info-list>
  </div>
  <div actions>
    <eas-buttons-menu *ngIf="buttons" [buttons]="buttons"></eas-buttons-menu>
  </div>
</ub-card>
